import React, { useEffect, useContext } from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { Math } from 'core-js';
import zipcodes from 'zipcodes';
import ColorKey from './reusableObjects/ColorKey';
import Chart from '../svg/Chart';
import { colors, breakpoints } from '../styles/utilities/settings';
import Scores from './Scores';
import Loading from './Loading';
import { AppContext } from '../App';
import { button } from '../styles/utilities/elements';
import { ContributingFactorsDesktop1 } from './ContributingFactors';
import AdditionlPests from './AdditionlPests';

/* eslint-disable no-undef */
export function getResults(zip, industry, setResults) {
  const data = new XMLHttpRequest();
  data.open(
    'GET',
    `https://pestpressureriskapi.azurewebsites.net/api/getriskprobabilitiesbyzipindustry/${zip}/${industry.name}`,
    true
  );
  data.onreadystatechange = () => {
    if (data.readyState === 4) {
      if (data.status === 200 || data.status === 0) {
        setResults(JSON.parse(data.responseText));
      }
    }
  };
  data.send(null);
}
/* eslint-enable no-undef */

const RiskScores = ({ industry, zipCode }) => {
  const { setResults } = useContext(AppContext);

  const isTabletOrMobile = useMediaQuery({
    query: `(max-width: ${breakpoints.ipadPort - 1}px)`,
  });
  useEffect(() => {
    /* eslint-disable react-hooks/exhaustive-deps */
    getResults(zipCode, industry, setResults);
  }, []);
  return (
    <AppContext.Consumer>
      {(value) => (
        <SRiskScores>
          <h2>Your Local Pest Risk</h2>
          <div className="app-content">
            <ColorKey />
            {value.results ? (
              <>
                {value.results.length !== 0 ? (
                  <>
                    <div className="app-container">
                      {value.results.map(
                        ({ PestTypeOverallPest, PestRiskProbability }) => (
                          <React.Fragment key={Math.random()}>
                            {PestTypeOverallPest === 'Over All Pest' && (
                              <Chart
                                percent={parseInt(PestRiskProbability, 0)}
                                content={`${PestTypeOverallPest.replace(
                                  'Over All',
                                  'Overall'
                                )}<br />Pressure Outlook`}
                              />
                            )}
                          </React.Fragment>
                        )
                      )}
                      <div className="copy">
                        <p>Pest Risk Scores For:</p>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: `<strong>${
                              industry.label
                            }</strong> in <br /><strong>${zipCode}</strong> ${
                              zipcodes.lookup(zipCode)
                                ? zipcodes.lookup(zipCode).city
                                : 'City not found'
                            }, ${
                              zipcodes.lookup(zipCode)
                                ? zipcodes.lookup(zipCode).state
                                : 'State not found'
                            }`,
                          }}
                        />
                      </div>
                    </div>
                    <Scores results={value.results} />
                  </>
                ) : (
                  <Loading justSpinner />
                )}
              </>
            ) : (
              <Loading justSpinner />
            )}
            <div className="factors">
              {value.results && !isTabletOrMobile && (
                <ContributingFactorsDesktop1 />
              )}
              <AdditionlPests industry={industry.label} />
            </div>

            <Back
              onClick={() => {
                value.setScoreWindow(false);
              }}
            >
              Check Another Location
            </Back>
          </div>
        </SRiskScores>
      )}
    </AppContext.Consumer>
  );
};

export default RiskScores;

const Back = styled.div`
  ${button};
  margin-top: 20px;
  cursor: pointer;
`;

const SRiskScores = styled.div`
  .app-content {
    background-color: ${colors.lightGray};
    padding: 30px;
  }

  .app-container {
    @media screen and (min-width: ${breakpoints.ipadLand}px) {
      display: flex;
      align-items: center;
    }

    @media screen and (max-width: ${breakpoints.ipadLand - 1}px) {
      max-width: 300px;
      margin: 0 auto;
    }

    .bg {
      stroke: ${colors.white} !important;
    }

    > * {
      @media screen and (min-width: ${breakpoints.ipadLand}px) {
        width: 50%;
      }
    }
  }

  .factors {
    h4,
    ul {
      text-align: left;
    }

    > ul {
      display: flex;
      list-style: none;
      margin: 0;

      li {
        margin-right: 20px;

        svg {
          display: inline-block;
          vertical-align: middle;
          margin: 0 10px 0 0;
        }
      }
    }
  }
`;
